// extracted by mini-css-extract-plugin
module.exports = {"root":"empty_root__GZn6p"};